import React from 'react'
import PropTypes from 'prop-types'


import './CoachAd.scss'

const CoachAd = (props) => (
  <div className='coach-ad-wrapper'>
    <object data={props.adSrc}>
      <img src={props.fallback} className='coach-ad-img' alt='Coach Advertisement' />
    </object>
  </div>
)

CoachAd.propTypes = {
  adSrc: PropTypes.string,
  fallback: PropTypes.string,
}

export default CoachAd
